@if(isLoadingGroup) {
	<mat-spinner mode="indeterminate" diameter="30" class="mx-a"></mat-spinner>
} @else {
	<form [formGroup]="formGroup">
		<app-card [inCardTitle]="vehicleGroup.name"
				  icon="arrow_back"
				  [iconDisabled]="isSaving"
				  (iconClicked)="navigateBack()">
			@if (saveError) {
				<mat-error>{{saveError}}</mat-error>
			}
			<div *appCardContentRaw>
				<mat-nav-list class="p-0">
					<a mat-list-item [routerLink]="['mobile-settings']">
						<div matListItemTitle>PlowOps Mobile</div>
						<div matListItemLine>Settings for PlowOps Mobile application</div>
						<div matListItemMeta>
							<mat-icon>arrow_right</mat-icon>
						</div>
					</a>
				</mat-nav-list>
			</div>

			<div *appCardContent class="my-8">
				<app-row-with-toggle primaryText="Stationary Alert"
									 secondaryText="Send alert if vehicle stops for extended duration"
									 formControlName="stationaryAlertSet">
				</app-row-with-toggle>
				@if (formGroup.controls['stationaryAlertSet'].value) {
					<div class="indent pb-8" formGroupName="stationaryConfiguration">
						<app-row-with-select primaryText="Duration"
											 [list]="STATIONARY_ALERT_LIST_OPTIONS"
											 listLabel="label"
											 listId="id"
											 formControlName="maxStationaryTime">
						</app-row-with-select>
						@if (formGroup.get('stationaryConfiguration.maxStationaryTime')?.hasError('required')) {
							<mat-error>Select stationary time value.</mat-error>
						}

						<mat-divider class="my-16"></mat-divider>

						<app-row-with-toggle primaryText="Notifications"
											 secondaryText="Get email notifications for stationary alerts"
											 [checked]="isEmailNotificationEnabled"
											 (checkedChange)="onNotificationToggleChange($event)">
						</app-row-with-toggle>

						@if (formGroup.get('stationaryConfiguration.notificationType')?.value !== StationaryNotificationType.NONE) {
							<div class="mt-8">
								<mat-radio-group class="form-radio-group mt-8" formControlName="notificationType">
									<mat-radio-button class="form-radio-button" [value]="StationaryNotificationType.LOGGED_IN_USERS">
										<div class="indent my-8">
											<div>Active Logged in Dashboard Users</div>
											<div class="secondary">Send notifications to users currently active on the Dashboard</div>
										</div>
									</mat-radio-button>
									<mat-divider></mat-divider>
									<mat-radio-button class="form-radio-button" [value]="StationaryNotificationType.SELECTED_RECIPIENTS">
										<div class="indent my-8">
											<div>Choose Recipients</div>
											<div class="secondary">Always send notifications to selected users whether logged in or not</div>
										</div>
									</mat-radio-button>
								</mat-radio-group>
							</div>

							@if (formGroup.get('stationaryConfiguration.notificationType')?.value === StationaryNotificationType.SELECTED_RECIPIENTS) {
								<div class="form-radio-button py-16 indent">
									<div>Recipients:</div>
									@if (notificationUsers && notificationUsers.length > 0) {
										<div class="mt-8">
											@for (user of notificationUsers; track user.email) {
												<div>
													<mat-checkbox [checked]="user.selected"
																  (change)="notificationUsersChanged(user, $event)">
														{{ user.email }}
													</mat-checkbox>
												</div>
											}
										</div>
									}
									@if (invalidRecipients && invalidRecipients.length > 0) {
										<div class="mt-8 text-warn font-size-12">
											<div>Invalid or inactive recipient(s) (will be removed on save):</div>
											@for (email of invalidRecipients; track email) {
												<div>- {{ email }}</div>
											}
										</div>
									}
									@if (formGroup.hasError('missingRecipient')) {
										<mat-error class="mt-8">
											Choose at least one recipient.
										</mat-error>
									}
								</div>
							}
						}
					</div>
				}
			</div>

			<div *appCardContent>
				<div class="settings-header-container mt-16">
					<div class="settings-header-title">
						Vehicles
					</div>
					<div class="settings-header-actions">
						@if (!isCartegraphEnabled) {
							<button mat-stroked-button
									(click)="addVehicle()">
								Add
							</button>
						}
					</div>
				</div>

				<mat-nav-list>
					<mat-menu #menuVehicle="matMenu">
						<ng-template matMenuContent let-vehicle="vehicle">
							<button mat-menu-item [routerLink]="['/' + RootRoute.SETTINGS, SettingsRoute.MANAGE_VEHICLES, 'vehicle', vehicle.id]">
								Open
							</button>
							@if (!isCartegraphEnabled) {
								<button mat-menu-item (click)="moveVehicle(vehicle)">
									Move
								</button>
								<button mat-menu-item (click)="deleteVehicle(vehicle)">
									Remove
								</button>
							}
						</ng-template>
					</mat-menu>

					@for (vehicle of vehicleDataSource.data(); track vehicle.id) {
						<mat-list-item [routerLink]="['/' + RootRoute.SETTINGS, SettingsRoute.MANAGE_VEHICLES, 'vehicle', vehicle.id]">
							<div matListItemTitle>{{vehicle.name}}</div>
							<div matListItemMeta>
								<button mat-icon-button
										(click)="$event.stopPropagation()"
										[matMenuTriggerFor]="menuVehicle"
										[matMenuTriggerData]="{vehicle:vehicle}"
										aria-label="Menu">
									<mat-icon>more_vert</mat-icon>
								</button>
							</div>
						</mat-list-item>
						@if (!$last) {
							<mat-divider></mat-divider>
						}
					}
					@if (vehicleDataSource.isLoading()) {
						<mat-progress-spinner mode="indeterminate" class="mx-a" diameter="30">
						</mat-progress-spinner>
					}
					<div appElementVisible (visibleChanged)="vehicleDataSource.dataEndVisible = $event"></div>
				</mat-nav-list>
				@if (!vehicleDataSource.data().length && !vehicleDataSource.isLoading()) {
					<div class="text-muted">No vehicles assigned to this group.</div>
				}
			</div>

		</app-card>
	</form>
}
